import React, {Component} from "react";
import PropTypes from "prop-types";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import initialState from "../../../reducers/communications/newCommunicationInitialState";
import {RequiredInput, Toggle} from "Ncontracts.Common.UI";
import {
    ADD_NEW_COMMUNICATION_POLL_OPTION,
    handleNewCommunicationPollOptionChange,
    handleNewCommunicationTextInputChange,
    removeNewCommunicationPollOption,
    TOGGLE_POLL_INCLUSION
} from "../../../actions/communications/newCommunicationAction";
import {imageCdnUrls} from "../../common/ImageCdnUrls";
import isEmpty from "../../../helpers/isEmpty";

class NewCommunicationPollForm extends Component {

    static propTypes = {
        addPollOption: PropTypes.func,
        handlePollOptionChange: PropTypes.func,
        handleTextInputChange: PropTypes.func,
        includesPoll: PropTypes.bool,
        pollOptions: PropTypes.arrayOf(PropTypes.string),
        pollQuestion: PropTypes.string,
        removePollOption: PropTypes.func,
        togglePollInclusion: PropTypes.func
    };

    static defaultProps = {
        ...initialState
    };

    constructor(props, context) {
        super(props, context);

        this.state = {
            hoveredPollOption: null,
            isPollQuestionInitialized: !isEmpty(this.props.pollQuestion)
        };
    }

    renderPollForm = () => {
        const {pollQuestion, addPollOption} = this.props;
        const isQuestionValid = !isEmpty(pollQuestion);
        const addOptionLink = this.props.pollOptions.length > 5 ? undefined :
            <div className="add-link"><a className="add-to-list-link" onClick={() => addPollOption()}>+ Add Answer</a></div>;

        return (
            <div className="new-poll-inputs">
                <div className="question-input">
                    <RequiredInput label={'Question'} validationMessage="Please enter a poll question"
                                   isValid={isQuestionValid} shouldValidate={this.state.isPollQuestionInitialized}>
                        <input name="pollQuestion"
                               className="input"
                               value={pollQuestion}
                               placeholder="Question"
                               maxLength={75}
                               onChange={e => this.handlePollQuestionChange(e)}
                        />
                    </RequiredInput>
                </div>
                <div className="poll-options-section">
                    <div className="validated-field">
                        <div className="label"><span className="required-label">*</span>Poll Response</div>
                        {addOptionLink}
                        {this.renderPollOptionInputs()}
                    </div>
                </div>
            </div>);
    };

    handlePollQuestionChange = e => {
        this.setState({...this.state, isPollQuestionInitialized: true});
        this.props.handleTextInputChange("pollQuestion", e.target.value);
    };

    renderPollOptionInputs = () => {
        const {pollOptions, handlePollOptionChange, removePollOption} = this.props;

        const optionInputs = pollOptions.map((option, index) => {
            const showDeleteIcon = this.state.hoveredPollOption === index && pollOptions.length > 2;
            return (
                <div className="poll-option" key={index} onMouseEnter={() => this.showOptionDeleteIcon(index)}
                     onMouseLeave={() => this.hideOptionDeleteIcon()}>
                    <input name="pollOption"
                           className="input"
                           value={option}
                           placeholder="Add answer"
                           maxLength={75}
                           onChange={e => handlePollOptionChange(index, e.target.value)}/>
                    {!showDeleteIcon ? undefined :
                        <img src={imageCdnUrls.x_red} width="15" height="15" onClick={() => removePollOption(index)}/>}
                </div>);
        });

        return (
            <div className="poll-option-inputs">
                {optionInputs}
            </div>
        );
    };

    showOptionDeleteIcon = index => {
        this.setState({...this.state, hoveredPollOption: index});
    };

    hideOptionDeleteIcon = () => {
        this.setState({...this.state, hoveredPollOption: null});
    };

    render() {
        const {includesPoll, togglePollInclusion} = this.props;
        const pollForm = includesPoll ? this.renderPollForm() : undefined;
        return (
            <div className="new-poll-form">
                <div className="small-toggle-with-inline-label">
                    <div className="label">Does this message require a Poll?</div>
                    <Toggle
                        className="toggle-small"
                        onChange={() => togglePollInclusion()}
                        defaultChecked={includesPoll}
                        icons={{
                            checked: <div className="toggle-option-yes">YES</div>,
                            unchecked: <div className="toggle-option-no">NO</div>
                        }}
                    />
                </div>
                {pollForm}
            </div>);
    }
}

const mapStateToProps = state => ({
    includesPoll: state.newCommunication.includesPoll,
    pollOptions: state.newCommunication.pollOptions,
    pollQuestion: state.newCommunication.pollQuestion
});

const mapDispatchToProps = dispatch => ({
    addPollOption: () => dispatch({type: ADD_NEW_COMMUNICATION_POLL_OPTION}),
    handlePollOptionChange: (index, value) => dispatch(handleNewCommunicationPollOptionChange(index, value)),
    handleTextInputChange: (name, value) => dispatch(handleNewCommunicationTextInputChange(name, value)),
    removePollOption: (index) => dispatch(removeNewCommunicationPollOption(index)),
    togglePollInclusion: () => dispatch({type: TOGGLE_POLL_INCLUSION})
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(NewCommunicationPollForm));
